export default __webpack_public_path__ + "static/media/FavoriteFilled.c74123fb.svg";